<div class="card measureToolboxComponent" #measureToolboxComponentRef>
  <!--- the card header -->
  <div class="card-header">
    <div class="row">
      <div class="col-md-9">
        <span translate>WIDGET.MEASURE.MEASURE_NUMBER</span> {{measureNumber}}
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="leaveComponent()">close</i>
      </div>
    </div>
  </div>

  <!-- the card body -->
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div #measureRef></div>
      </div>
    </div>
  </div>
</div>
